import { useTranslation } from "react-i18next";
import { Switch } from "../../../components/ui/Switch";

export function SearchRoomScopeToggle({
  roomName,
  isScopedToRoom,
  onToggle,
}: {
  roomName: string;
  isScopedToRoom: boolean;
  onToggle: (next: boolean) => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex w-full items-center gap-2 py-3">
      <div className="flex flex-1 flex-col gap-0.5">
        <span className="text-sm/tight font-semibold  text-ds-black">
          {t("This room only")}
        </span>
        <span className="truncate text-xs text-ds-slate-700">{roomName}</span>
      </div>
      <Switch
        checked={isScopedToRoom}
        onCheckedChange={onToggle}
        label={t("Scope search to {{roomName}}", { roomName })}
      />
    </div>
  );
}
